module.exports = __webpack_public_path__ + "img/sacDesktop-es-ES.a5d64168.png";